package ai.flowstorm.common.auth

import ai.flowstorm.common.state.LocalStorageDelegate
import js.core.jso
import js.uri.encodeURI
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.coroutines.launch
import module.OAuth2Client
import module.OAuth2Token
import module.TokenResponse
import kotlin.js.Promise

class OAuth2Provider : AbstractOAuth2Provider() {

    private val clientSettings = jso<dynamic> {
        server = "https://keycloak.promethist.ai/"
        clientId = "flowstorm"
        clientSecret = ""
        discoveryEndpoint = "/realms/promethist/.well-known/openid-configuration"
    }

    private val redirectUri = window.location.origin + "/"

    private val client: OAuth2Client = createClient()

    private lateinit var tokens: OAuth2Token

    private var refreshToken by LocalStorageDelegate(String::class, "auth")

    override fun login() {
        mainScope.launch {
            redirect()
        }
    }

    override fun logout() {
        refreshToken = ""
        window.location.href = clientSettings.server + "realms/promethist/protocol/openid-connect/logout?post_logout_redirect_uri=" + encodeURI(redirectUri) +"&id_token_hint=" + AuthService.context.idToken.token
    }

    override fun signup() {
        error("Unsupported")
    }

    suspend fun redirect() {
        val urlPromise: Promise<String> = client.authorizationCode.getAuthorizeUri(jso {
            this.redirectUri = redirectUri
            scope = arrayOf("profile", "openid")

        }) as Promise<String>

        val url = urlPromise.await()
        window.location.href = url
    }

    override suspend fun authenticate() {
        if (window.location.search.contains("code=")) {
            val authorizationCode =
                window.location.search.split("&").single { it.startsWith("code") }.substringAfter("code=")
            processTokens(exchangeCodeForTokens(authorizationCode))
            window.history.replaceState(null, document.title, "/")

        } else if (refreshToken?.takeIf { it.isNotEmpty() } != null) {
            try {
                refreshToken()
            } catch (t:Throwable) {
                console.log("Invalid refresh token")
            }
        }
    }

    override suspend fun refreshToken() {
        processTokens(refreshTokens())
    }

    private fun createClient(): OAuth2Client = OAuth2Client(clientSettings)

    private suspend fun processTokens(tokens: Promise<TokenResponse>) {
        tokens.await().let {
            authService.context = AuthContext(
                JwtToken(it.id_token),
                JwtToken(it.access_token),
                false,
            )
            refreshToken = it.refresh_token

            scheduleRefresh(it.expires_in)
        }
    }

    private fun exchangeCodeForTokens(authorizationCode: String): Promise<TokenResponse> {
        val body = jso<dynamic> {
            grant_type = "authorization_code"
            code = authorizationCode
            redirect_uri = redirectUri
        }
        return client.request("tokenEndpoint", body)
    }

    private fun refreshTokens(): Promise<TokenResponse> {
        val body = jso<dynamic> {
            grant_type = "refresh_token"
            refresh_token = refreshToken
        }

        return client.request("tokenEndpoint", body)
    }
}
